export default __webpack_public_path__ + "static/media/Bull.43aa4281.png";